import React from "react";
import "./CustomInput.scss"
import cal from "../../assets/calendar-filled.svg";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


const CustomDatePicker = ({ label, icon, value, onChange, placeholder, required, error, errorText, disable, type = "text", maxDate }) => {


    return (
        <div className="CustomInput">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}>
                {icon && <img className="CustomInput-container-icon" alt="" src={cal} />}
                <DatePicker selected={value} onChange={onChange}
                    className="CustomInput-container-input"
                    placeholder={placeholder}
                    maxDate={maxDate}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default CustomDatePicker